import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

const CreditApplicationFail = () => {
  const router = useRouter();
  const { bottom } = useSafeAreaInsets();
  const { t: translatedText } = useTranslation('believe');
  const { isBelieveDay0M2 } = useLocalSearchParams<{
    isBelieveDay0M2: string;
  }>();
  const subcategory =
    isBelieveDay0M2 === 'true'
      ? 'believe_day_0_application'
      : 'believe_application';

  useViewDidFocusScreenAnalyticsEvent({
    key: 'believeDeclined',
    customAttributes: { subcategory },
  });

  const handleDoneAnalytics = usePressableAnalytics({
    analyticsId: 'done',
    customAttributes: {
      cta: 'Ok',
      subcategory,
    },
  });

  const handleAnalyticsAndRedirect = () => {
    handleDoneAnalytics();
    router.replace('/');
  };

  return (
    <View style={[styles.container, { paddingBottom: bottom }]}>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ErrorScreen
        screenType={ErrorScreenType.Error}
        messageHeadline={translatedText('application.error.title')}
        messageBody={translatedText('application.error.subTitle')}
        primaryButton={{
          title: translatedText('application.error.primaryButton'),
          onPress: function (): void {
            handleAnalyticsAndRedirect();
          },
          isLoading: undefined,
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.s,
  },
});

export default CreditApplicationFail;
